"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _paginationButton = _interopRequireDefault(require("./_paginationButton"));

var _paginationLink = _interopRequireDefault(require("./_paginationLink"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 2px 6px;\n  padding: 2px 14px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 28px;\n  margin: -5px 0;\n  padding: 5px;\n  border-left: 1px solid black;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  user-select: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 400px;\n  height: 20px;\n  animation: ", " 1s infinite ease-in-out;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n      background-color: rgba(165, 165, 165, 0.1)\n  }\n  50% {\n      background-color: rgba(165, 165, 165, 0.3)\n  }\n  100% {\n      background-color: rgba(165, 165, 165, 0.1)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var pulseAnimation = (0, _styledComponents.keyframes)(_templateObject());

var PaginationLoader = _styledComponents["default"].div(_templateObject2(), pulseAnimation);

var StyledFlexContainer = _styledComponents["default"].div(_templateObject3());

var StyledDivider = _styledComponents["default"].div(_templateObject4());

var StyledText = _styledComponents["default"].div(_templateObject5());

var getStartPage = function getStartPage(_ref) {
  var pagerSize = _ref.pagerSize,
      currentPage = _ref.currentPage;
  var maxBufferPages = Math.floor(pagerSize / 2);
  var bufferPagesFromStart = currentPage < maxBufferPages ? currentPage - 1 : maxBufferPages;

  if (currentPage === bufferPagesFromStart) {
    return 1;
  }

  return currentPage > bufferPagesFromStart ? currentPage - bufferPagesFromStart : currentPage;
};

var getPagerData = function getPagerData(_ref2) {
  var totalPages = _ref2.totalPages,
      currentPage = _ref2.currentPage,
      pagerSize = _ref2.pagerSize;
  var pageRange = pagerSize > totalPages ? totalPages : pagerSize;
  var canDisplayFirstLast = totalPages > pageRange;
  var startPage = getStartPage({
    pagerSize: pagerSize,
    currentPage: currentPage
  });
  var endPage = startPage + (pageRange - 1);

  if (endPage > totalPages) {
    var numberOfBufferPages = endPage - totalPages;
    startPage -= numberOfBufferPages;
    endPage = totalPages;
  }

  var pagesToBeDisplayed = Array.from({
    length: endPage + 1 - startPage
  }).map(function (val, index) {
    return index + startPage;
  });
  return {
    pagesToBeDisplayed: pagesToBeDisplayed,
    canDisplayFirstLast: canDisplayFirstLast
  };
};

var getPaginationButtonProps = function getPaginationButtonProps(_ref3) {
  var currentPage = _ref3.currentPage,
      totalPages = _ref3.totalPages,
      isLoading = _ref3.isLoading;
  var isFirstPrevButtonsDisabled = currentPage === 1 || isLoading;
  var isLastNextButtonsDisabled = currentPage === totalPages || isLoading;
  return {
    isFirstPrevButtonsDisabled: isFirstPrevButtonsDisabled,
    isLastNextButtonsDisabled: isLastNextButtonsDisabled
  };
};

var Pagination = function Pagination(props) {
  var totalPages = props.totalPages,
      currentPage = props.currentPage,
      pagerSize = props.pagerSize,
      initialFetchDone = props.initialFetchDone,
      displayFirstLast = props.displayFirstLast,
      isLoading = props.isLoading,
      changePage = props.changePage,
      resultsPerPage = props.resultsPerPage,
      canSetResultsPerPage = props.canSetResultsPerPage,
      setResultsPerPage = props.setResultsPerPage,
      resultsPerPageOptions = props.resultsPerPageOptions;

  var _getPagerData = getPagerData({
    totalPages: totalPages,
    currentPage: currentPage,
    pagerSize: pagerSize
  }),
      pagesToBeDisplayed = _getPagerData.pagesToBeDisplayed,
      canDisplayFirstLast = _getPagerData.canDisplayFirstLast;

  var _getPaginationButtonP = getPaginationButtonProps({
    currentPage: currentPage,
    totalPages: totalPages,
    isLoading: isLoading
  }),
      isFirstPrevButtonsDisabled = _getPaginationButtonP.isFirstPrevButtonsDisabled,
      isLastNextButtonsDisabled = _getPaginationButtonP.isLastNextButtonsDisabled;

  var shouldDisplayFirstLast = displayFirstLast && canDisplayFirstLast;

  if (!initialFetchDone) {
    return _react["default"].createElement(PaginationLoader, null);
  }

  return _react["default"].createElement(StyledFlexContainer, null, canSetResultsPerPage && _react["default"].createElement(StyledFlexContainer, null, _react["default"].createElement(_dropdown["default"], {
    noMinWidth: true,
    listWidth: "100%",
    borderOnHoverOnly: true,
    selected: resultsPerPage,
    renderType: 'button',
    onSelection: setResultsPerPage
  }, resultsPerPageOptions.map(function (val) {
    return _react["default"].createElement(_dropdown["default"].MenuItem, {
      value: val,
      label: val
    });
  })), _react["default"].createElement(StyledText, {
    size: 5
  }, "Results Per Page"), _react["default"].createElement(StyledDivider, null)), shouldDisplayFirstLast && _react["default"].createElement(_paginationButton["default"], {
    changePage: changePage,
    pageNumber: 1,
    isDisabled: isFirstPrevButtonsDisabled,
    buttonText: "First",
    hasLeftIcon: true
  }), _react["default"].createElement(_paginationButton["default"], {
    changePage: changePage,
    pageNumber: currentPage - 1,
    isDisabled: isFirstPrevButtonsDisabled,
    buttonText: "Prev",
    hasLeftIcon: true
  }), pagesToBeDisplayed.map(function (page, index) {
    return _react["default"].createElement(_paginationLink["default"], {
      changePage: changePage,
      pageNumber: page,
      isDisabled: isLoading,
      isActive: currentPage === page
    });
  }), _react["default"].createElement(_paginationButton["default"], {
    changePage: changePage,
    pageNumber: currentPage + 1,
    isDisabled: isLastNextButtonsDisabled,
    buttonText: "Next",
    hasLeftIcon: false
  }), shouldDisplayFirstLast && _react["default"].createElement(_paginationButton["default"], {
    changePage: changePage,
    pageNumber: totalPages,
    isDisabled: isLastNextButtonsDisabled,
    buttonText: "Last",
    hasLeftIcon: false
  }));
};

Pagination.defaultProps = {
  totalPages: 8,
  currentPage: 1,
  pagerSize: 8,
  initialFetchDone: true,
  isLoading: false,
  displayFirstLast: false,
  canSetResultsPerPage: true,
  resultsPerPage: 10,
  resultsPerPageOptions: [10, 11, 12, 13, 14, 15]
};
Pagination.propTypes = {
  totalPages: _propTypes["default"].number,
  currentPage: _propTypes["default"].number,
  pagerSize: _propTypes["default"].number,
  initialFetchDone: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  displayFirstLast: _propTypes["default"].bool,
  resultsPerPage: _propTypes["default"].number,
  canSetResultsPerPage: _propTypes["default"].bool,
  changePage: _propTypes["default"].func.isRequired,
  setResultsPerPage: _propTypes["default"].func.isRequired
};
var _default = Pagination;
exports["default"] = _default;